import type { HttpsCallableOptions } from 'firebase/functions';

// Output generation can legitimately take several minutes on a cold cache.
// Keep the client deadline above the 540-second Cloud Function deadline;
// otherwise the Firebase SDK aborts after its 70-second default timeout while
// the server is still computing and caching the report.
export const OUTPUT_REPORT_CALLABLE_OPTIONS = {
  timeout: 600_000,
} satisfies HttpsCallableOptions;

export type ReportGeneration = {
  generatedAt: string;
  source: 'nightly' | 'manual' | 'on-demand';
  cached: boolean;
  version: number;
};

export type ReportDataWarning = {
  code: string;
  source: 'master' | 'mail' | 'responses' | 'configuration' | 'mixed';
  title: string;
  message: string;
};

export function formatReportGeneration(generation: ReportGeneration): string {
  const date = new Date(generation.generatedAt);
  const formatted = Number.isNaN(date.getTime())
    ? 'data non disponibile'
    : new Intl.DateTimeFormat('it-IT', {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(date);
  if (generation.source === 'nightly') return `Pregenerato automaticamente il ${formatted}`;
  if (generation.source === 'manual') return `Rigenerato manualmente il ${formatted}`;
  return `Generato su richiesta il ${formatted}`;
}
